import { Alert, Typography } from "@platform/design-system";

import { COMPLETE_ERROR_CODES } from "../constants";

function UploadFileError({ fileName, error, onClose, code }) {
  return (
    <Alert
      severity="warning"
      sx={{ fontSize: "0.8rem", marginBottom: "8px" }}
      onClose={onClose}
    >
      {COMPLETE_ERROR_CODES.includes(code) ? (
        error
      ) : (
        <>
          <Typography variant="caption" component="span" color="inherit">
            <strong>{fileName}</strong>
          </Typography>{" "}
          could not be uploaded. {error}
        </>
      )}
    </Alert>
  );
}

export default UploadFileError;
